// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__4yU4m","succesfulText":"ResetPassword_succesfulText__nwHH0"};